import { render, staticRenderFns } from "./GoldRedeem.vue?vue&type=template&id=0edc763b"
import script from "./GoldRedeem.vue?vue&type=script&lang=js"
export * from "./GoldRedeem.vue?vue&type=script&lang=js"
import style0 from "./GoldRedeem.vue?vue&type=style&index=0&id=0edc763b&prod&lang=css"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports